import { Avatar, Box, IconButton, Typography, makeStyles, FormControl, FormControlLabel, Checkbox } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import React, { useContext, useEffect } from 'react'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { usePosition } from '../../hooks/CompanyConfiguration/usePosition'
import { useFeatures } from '../../hooks/Features/useFeatures'
import { handleSelectedItem, isSelected } from '../../shared/constants'
import CustomButton from '../CustomButton'
import CustomDetail from '../CustomDetail'
import CustomDialog from '../CustomDialog'
import CustomHeading from '../CustomHeading'

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: '400px',
  },
  heading: {
    fontSize: '14px',
    lineHeight: '19px',
    fontWeight: 600,
    paddingLeft: '20px',
    fontStyle: 'Open sans',
  },
  btn: {
    margin: '30px 0px 0px 100px',
    maxWidth: '140px',
  },
}))
export default function FilterPopup({ open, handleClose, details, heading, filterOptions, positionId, setPositionId, filterByPosition }) {
  const classes = useStyles()

  const { getAllPosition } = usePosition()
  const { positions } = useContext(ConfigurationContext)

  //console.log('POSITIONS : ', positions)
  useEffect(() => {
    getAllPosition()
  }, [])

  const filterDataByPsoition = () => {
    filterByPosition()
    handleClose()
  }

  const data = filterOptions ? filterOptions : positions
  return (
    <CustomDialog open={heading === 'Position' && open} handleClose={handleClose} className={classes.root}>
      <Box display="flex" justifyContent="space-between">
        <CustomHeading heading={heading} />
        <IconButton color="inherit" onClick={handleClose} style={{ position: 'relative', top: '-17px', left: '18px' }}>
          <Close />
        </IconButton>
      </Box>
      <FormControl component="fieldset">
        {data &&
          data.map((item, index) => {
            const isItemSelected = isSelected(item, positionId)

            return (
              <FormControlLabel
                value="start"
                control={<Checkbox color="primary" checked={isItemSelected} />}
                label={item.positionName}
                labelPlacement="start"
                style={{ marginLeft: '50px' }}
                key={index}
                onClick={() => handleSelectedItem(item, positionId, setPositionId)}
              />
            )
          })}

        <CustomButton text="Filter" className={classes.btn} handleSubmit={filterDataByPsoition} />
      </FormControl>
    </CustomDialog>
  )
}
